import { createTheme } from '@mui/material';
import { defaultStyleComponents } from './defaultStyleComponents';
import { defaultDarkColor, defaultLightColor } from './defaultColors';

export const brownLightTheme = createTheme({
  components: { ...defaultStyleComponents },
  spacing: (abs: number) => `${0.35 * abs}rem`,
  palette: {
    mode: 'light',
    primary: {
      main: '#D2691E',
      900: '#291408',
      800: '#522810',
      700: '#7B3C18',
      600: '#A45020',
      500: '#D2691E',
      400: '#DB874B',
      300: '#E4A578',
      200: '#EDC3A5',
      100: '#F6E1D2',
      50: '#FBF0E9',
    },
    ...defaultLightColor,
    customColor: {
      main: '#D2691E',
      100: '#A45020',
      gradient:
        'linear-gradient(90deg, rgba(210, 105, 30, 0.1) 0%, rgba(210, 105, 30, 0.3) 100%)',
    },
    customColor2: {
      main: '#141414',
    },
    customColorTable: {
      main: '#D2691E',
      oddRow: '#FBF0E9',
    },
  },
});

export const brownDarkTheme = createTheme({
  components: { ...defaultStyleComponents },
  spacing: (abs: number) => `${0.35 * abs}rem`,
  palette: {
    mode: 'dark',
    primary: {
      main: '#D2691E',
      900: '#141414',
      100: '#291408',
      700: '#522810',
      600: '#7B3C18',
      500: '#A45020',
      400: '#D2691E',
      300: '#DB874B',
      200: '#E4A578',
      800: '#1a1a1a',
      50: '#262626',
    },
    ...defaultDarkColor,
    customColor: {
      main: '#D2691E',
      100: '#DB874B',
      gradient:
        'linear-gradient(90deg, rgba(20, 20, 20, 0.8) 0%, rgba(210, 105, 30, 0.3) 100%)',
    },
    customColor2: {
      main: '#141414',
    },
    customColorTable: {
      main: '#D2691E',
      oddRow: '#1a1a1a',
    },
  },
});
